<template lang="pug">
modal.rubrica-settings-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='invalidForm'
  :process-button-label='$t("button.save")'
  :title='$t("modal.date_settings.title")'
  @opened='onOpenModal'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12
    form.needs-validation
      .form-group
        label(for='field-date') {{ $t('modal.date_settings.instruction') }}
        .form-control-icon
          icon(name='calendar-days')
          date-picker-input#field-date.form-control(
            :key='element.id'
            :placeholder='$t("modal.date_settings.placeholder")'
            @blur='validate'
            @change='validate'
            required
            type='text'
            v-model='element.value'
          )
          .invalid-feedback {{ $t('modal.date_settings.invalid_feedback') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import DatePickerInput from '@/ui/molecules/DatePickerInput.vue';

export default {
  components: {
    Modal,
    DatePickerInput,
    Icon,
  },
  data() {
    return {
      element: {},
      invalidForm: true,
    };
  },
  methods: {
    onOpenModal() {
      this.validate();
      if (!this.element.value) {
        window
          .jQuery('#field-date + .date-input')
          .removeClass('is-valid')
          .removeClass('is-invalid');
      }
    },
    process() {
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
    validate() {
      const isValid = Boolean(this.element.value);
      const feedbackElements = document.querySelectorAll('.invalid-feedback');

      window
        .jQuery('#field-date + .date-input')
        .toggleClass('is-valid', isValid)
        .toggleClass('is-invalid', !isValid);

      this.invalidForm = !isValid;

      feedbackElements.forEach((element) => {
        element.style.display =
          isValid || this.element.value !== null ? 'none' : 'block';
      });
    },
  },
};
</script>
<style lang="stylus">
.rubrica-settings-modal
  .form-check-label
    margin: .2rem 0 0 .5rem
</style>
